export const LimitTypeEnum = {
  ResponsePerMonth: 0,
  ActiveQuizzes: 1,
  QuizReportUserLimit: 2,
  AIQuestionsPerQuiz: 3,
  ContentInputLengthPerQuiz: 4,
}
